import React, { useState } from 'react';
import { Search, Menu, PlusCircle, X } from 'lucide-react';

import QR from '../../assets/qr.jpeg';

interface AccountNavbarProps {
  userData: any;
  onMenuClick: () => void;
}

const AccountNavbar = ({ userData, onMenuClick }: AccountNavbarProps) => {
  const [showAddFund, setShowAddFund] = useState(false);

  return (
    <>
      <header className="h-[100px] md:h-[88px] flex items-center justify-between px-4 md:px-8 shrink-0 relative z-20 bg-transparent md:bg-white md:border-b md:border-[#f1f5f9]">
        
        {/* Mobile Menu & Greeting */}
        <div className="flex items-center gap-3 md:gap-4">
          <button onClick={onMenuClick} className="md:hidden p-2 text-white bg-white/10 hover:bg-white/20 rounded-[14px] backdrop-blur-sm transition-all">
            <Menu size={24} strokeWidth={2.5} />
          </button>

          <div className="md:hidden flex items-center gap-3">
            <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white font-black shadow-sm backdrop-blur-sm border border-white/20">
              {userData?.first_name?.charAt(0)}{userData?.last_name?.charAt(0)}
            </div>
            <div>
              <p className="text-[10px] text-white/70 font-black uppercase tracking-[0.1em] leading-tight">Welcome back,</p>
              <p className="text-[16px] font-black text-white leading-tight">{userData?.first_name}</p>
            </div>
          </div>
        </div>

        {/* Desktop Search */}
        <div className="hidden md:flex items-center bg-[#f8fafc] hover:bg-white rounded-[16px] px-5 py-3 w-[400px] border border-[#f1f5f9] focus-within:border-[#bfdbfe] focus-within:bg-white focus-within:shadow-[0_0_0_4px_rgba(59,130,246,0.1)] transition-all">
          <Search size={18} className="text-[#94a3b8] mr-3" strokeWidth={2.5} />
          <input type="text" placeholder="Search stocks, transactions..." className="bg-transparent border-none outline-none text-[14px] font-bold w-full text-[#0f172a] placeholder-[#94a3b8]" />
        </div>
        
        {/* Right Actions */}
        <div className="flex items-center gap-4 md:gap-7">
          
          {/* Naya Add Funds Button (Replaced Notification) */}
          <button 
            onClick={() => setShowAddFund(true)}
            className="flex items-center gap-2 bg-emerald-100 hover:bg-emerald-200 text-emerald-700 px-4 py-2.5 rounded-[14px] font-black transition-all text-sm shadow-sm"
          >
            <PlusCircle size={20} strokeWidth={2.5} />
            <span className="hidden md:block">Add Funds</span>
          </button>
          
          {/* Desktop Profile Info */}
          <div className="hidden md:flex items-center gap-4 pl-7 border-l border-[#f1f5f9]">
            <div className="text-right">
              <p className="text-[14px] font-black text-[#0f172a]">{userData?.first_name} {userData?.last_name}</p>
              <p className="text-[10px] font-black text-[#94a3b8] uppercase tracking-[0.1em]">{userData?.login_id}</p>
            </div>
            <div className="w-12 h-12 bg-[#eff6ff] rounded-[14px] flex items-center justify-center text-[#3b82f6] font-black shadow-[0_4px_10px_rgba(59,130,246,0.15)]">
              {userData?.first_name?.charAt(0)}{userData?.last_name?.charAt(0)}
            </div>
          </div>
        </div>
      </header>

      {/* Add Fund Popup Modal */}
      {showAddFund && (
        <div className="fixed inset-0 bg-[#0f172a]/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 transition-opacity">
          <div className="bg-white rounded-[30px] p-8 w-full max-w-sm shadow-2xl relative animate-[fadeIn_0.2s_ease-out]">
            <button onClick={() => setShowAddFund(false)} className="absolute top-4 right-4 p-2 text-[#94a3b8] hover:bg-[#f1f5f9] rounded-full transition-colors">
              <X size={20} strokeWidth={2.5} />
            </button>
            <div className="text-center">
              <h2 className="text-2xl font-black text-[#0f172a] mb-2">Add Funds</h2>
              <p className="text-sm font-bold text-[#64748b] mb-6">Scan QR or use UPI ID to add funds</p>
              
              <div className="bg-[#f8fafc] p-4 rounded-[20px] border border-[#f1f5f9] flex justify-center mb-6">
                {/* Yahan aap apna actual QR Code image laga sakte hain */}
                <img src={QR} alt="UPI QR" className="w-[180px] h-[180px] rounded-xl shadow-sm mix-blend-multiply" />
              </div>

              <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-3">
                <p className="text-[11px] font-black text-emerald-600 uppercase tracking-widest mb-1">UPI ID</p>
                <p className="text-lg font-black text-[#0f172a] tracking-wider selection:bg-emerald-200">moti.lalalgo@axl</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountNavbar;